const PaymentMethod = Object.freeze({
	STRIPE: "stripe",
	PAYSTACK: "paystack",
	PROMOCODE: "promocode",
	CUSTOM: "custom",
});
export default PaymentMethod;